import React from 'react'

import './App.scss'
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom'

import { HomePage } from './home/HomePage'
import { LandingPage } from './landing/LandingPage'

function App () {
  return (
    <Router basename={'data/published_data_library'}>
      <Routes>
        <Route path='/catalogue/10.5285/:uuid' element={<LandingPage />}></Route>
        <Route path='/' element={<HomePage />}></Route>
      </Routes>
    </Router>
  )
}

export default App
